import { dismissAlert } from '@calendly/alert';
import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import changeSet from 'core/change_set';
import { useEventTypeContext } from 'features/event_type_provider';
import { useUpsertUserGuideStepMutation } from 'features/user_guide';
const footerContainerIsManagedCss = "f17x11xp";
const footerContainerCss = "f1a9sb71";
const FooterContainer = forwardRef((props, ref) => {
  const {
    isManaged,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-testid="event-type-editor-footer" className={classNames(footerContainerCss, {
    [footerContainerIsManagedCss]: isManaged
  }, props.className)} />;
});
export const Footer = ({
  isManaged = false,
  saveDisabled = false,
  onCancel = () => {}
}) => {
  const dispatch = useDispatch();
  const [upsertStep] = useUpsertUserGuideStepMutation();
  const {
    isCreation
  } = useEventTypeContext();
  const {
    isSubmitting
  } = useFormContext();
  const resolveCancelBtnStyle = useCallback(() => saveDisabled ? 'primary' : 'ghost', [saveDisabled]);
  const cancelActions = () => {
    dispatch(dismissAlert());
    onCancel();
  };
  const handleCancel = () => {
    if (isCreation && !changeSet.confirmReset()) {
      return false;
    }
    return cancelActions();
  };
  const handleSubmit = () => {
    upsertStep({
      identifier: 'customize_and_share_first_et',
      status: 'completed'
    });
  };
  return <FooterContainer isManaged={isManaged}>
      <Button decoration={resolveCancelBtnStyle()} onClick={handleCancel} spacingRight={8}>
        {saveDisabled ? I18n.t('publisher.action.done') : I18n.t('publisher.action.cancel')}
      </Button>
      {!saveDisabled && <Button type="submit" onClick={handleSubmit} loading={isSubmitting} spacingRight={8}>
          {I18n.t('publisher.event_type_editor.footer.save_and_close')}
        </Button>}
    </FooterContainer>;
};

require("./footer.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");